import { useState, useEffect, useCallback, useRef } from 'react';
import {
  isLoggedIn,
  checkLoginStatus,
  startOAuthLogin,
  clearUserToken,
} from 'wortou/browser';

export function useAuth() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loggingIn, setLoggingIn] = useState(false);
  const loginInFlight = useRef(false);

  useEffect(() => {
    checkLoginStatus().then((status) => {
      setLoggedIn(status);
      setLoading(false);
    });
  }, []);

  const login = useCallback(async () => {
    // Guard: prevent multiple concurrent login attempts.
    // startOAuthLogin() is async (PKCE crypto), and each call overwrites
    // the PKCE state in sessionStorage. Allowing concurrent calls causes
    // the redirect to use stale state, making the callback fail.
    if (loginInFlight.current) return;
    loginInFlight.current = true;
    setLoggingIn(true);

    try {
      await startOAuthLogin();
      // After this line, the browser navigates away (redirect mode).
      // If we somehow reach here, reset the guard.
    } catch (err) {
      console.error('[useAuth] login failed:', err);
      loginInFlight.current = false;
      setLoggingIn(false);
    }
  }, []);

  const logout = useCallback(() => {
    clearUserToken();
    setLoggedIn(false);
  }, []);

  return { loggedIn, loading, loggingIn, login, logout };
}
